import { useEffect } from 'react';
import { cssVars, globalStyles, editModeClass } from './App.global.styles';
import { AuthContextProvider } from './context/AuthContext';
import { EditModeContextProvider, useEditMode } from './context/EditModeContext';
import { ProductContextProvider } from './context/ProductContext';
import { AppsMenuContextProvider } from './context/AppsMenuContext';
import { ChartererContextProvider } from './context/ChartererContext';
import { CategoryDocumentsProvider } from './context/CategoryDocumentsContext';
import { AppSettingsStateProvider } from './context/AppSettingsStateContext';
import { QueryParamsProvider } from 'odfjell-query-manager/QueryParamsContext';
import AppRouter from './route/AppRouter';

// Inner component that uses EditModeContext
function AppContent() {
    const { isInEditMode } = useEditMode();

    // Apply edit-mode class to body element when edit mode is active
    useEffect(() => {
        if (isInEditMode) {
            document.body.classList.add('edit-mode');
        } else {
            document.body.classList.remove('edit-mode');
        }

        return () => {
            document.body.classList.remove('edit-mode');
        };
    }, [isInEditMode]);

    return <AppRouter />;
}

function App() {
    return (
        <div className={`${cssVars} ${globalStyles} ${editModeClass}`}>
            <AppSettingsStateProvider>
                <QueryParamsProvider>
                    <AuthContextProvider>
                        <AppsMenuContextProvider>
                            <ChartererContextProvider>
                                <CategoryDocumentsProvider>
                                    <EditModeContextProvider>
                                        <ProductContextProvider>
                                            <AppContent />
                                        </ProductContextProvider>
                                    </EditModeContextProvider>
                                </CategoryDocumentsProvider>
                            </ChartererContextProvider>
                        </AppsMenuContextProvider>
                    </AuthContextProvider>
                </QueryParamsProvider>
            </AppSettingsStateProvider>
        </div>
    );
}

export default App;
